<div class="max-h-9 max-w-[110px]">
  <img [src]="logoUrl" alt="Logo" />
</div>
